const _utils = function () { var t = { getCart: function () { return $.getJSON("/cart.js") }, getProductJSON: function (t) { return $.getJSON(`/products/${t}.js`) }, checkVariantInCart: function (n) { return new Promise(function (e, r) { t.getCart().then(function (t) { var r = t.items.find(function (t) { return t.variant_id == n }); e(void 0 !== r) }) }) }, refreshCart: function () { setTimeout(function () { window.location.reload() }, 1e3) }, addItemsToCart: function (n) { return new Promise(function (e, r) { async.eachSeries(n, function (n, e) { t.addItemToCart(n).then(function () { e() }) }, function (t) { t && console.error(t), e() }) }) }, addItemToCart: function (t) { var n = { quantity: t.quantity, id: t.variant_id }; return void 0 !== t.properties && (n.properties = t.properties), console.log(n), new Promise(function (t, e) { $.ajax({ type: "POST", url: "/cart/add.js", data: n, dataType: "json", success: function (n) { t(n) }, error: function (t) { e(t) } }) }) }, removeItemsFromCart: function (t) { if (0 != t.length) { var n = {}; return t.forEach(function (t) { n[t.key] = 0 }), new Promise(function (t, e) { $.post("/cart/update.js", { updates: n, success: function () { t() } }) }) } }, updateCart: function (t) { if (t) return new Promise(function (n, e) { $.ajax({ type: "POST", url: "/cart/update.js", async: !0, data: { updates: t }, dataType: "json", success: function (t) { console.log(t), n(t) }, error: function (t) { console.error(t), e(t) } }) }) }, updateCartAttribute: function (t) { var n = { attributes: {} }; return n.attributes = t.attributes, new Promise(function (t, e) { $.ajax("/cart/update.js", { type: "POST", data: n, success: function () { t() } }) }) }, observeMutations: function (t, n) { if (0 != document.querySelectorAll(t).length) { var e = new MutationObserver(n); return e.observe(document.querySelector(t), { attributes: !0, childList: !0, characterData: !0 }), e } }, debounce: function (t, n, e) { var r; return function () { var o = this, a = arguments, u = e && !r; clearTimeout(r), r = setTimeout(function () { r = null, e || t.apply(o, a) }, n), u && t.apply(o, a) } }, onElementLoad: function (t, n) { var e = !1, r = setInterval(function () { document.querySelectorAll(t).length && (console.log(t + " loaded!"), e = !0), e && (clearInterval(r), n()) }, 100) } }; return t }();

(function ($) {
  var upsell_container = '#cart-upsells';

  function initUpsellsApp() {
    Vue.filter('resize_image', function (src, size) {
      var resized = src || '';
      resized = resized.replace('.png', `_${size}.png`);
      resized = resized.replace('.jpg', `_${size}.jpg`);

      return resized;
    });

    Vue.filter('handle', function (value) {
      return value.replace('-', ' ');
    });

    Vue.filter('unhandle', function (value) {
      return value.replace('-', ' ');
    });

    Vue.filter('format_money', function (value) {
      //return theme.Currency.formatMoney(value, theme.settings.moneyFormat);
      var formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value / 100);
      return formatted;
    });

    var upsells = window.upsells = new Vue({
      el: upsell_container,

      data: {
        productsToUpsell: []
      },

      mounted: function () { },

      computed: {},

      updated: function () {
        this.$nextTick(function () {
          var _this = this;
          _this.loadUpsells();
        });
      },

      methods: {
        renderUpsell: function () {
          var upsellsInCart = document.querySelector('#CartContainer .upsell-items');
          var upsellsCartContainer = document.querySelector('#CartContainer .drawer__footer .cart-upsells-container');
          
          if (upsellsInCart !== null) upsellsInCart.remove();
          
          if (upsellsCartContainer !== null) {
            upsellsCartContainer.insertAdjacentHTML('beforeEnd', $(upsell_container).find('.upsell-items')[0].outerHTML);
          }
        },

        initUpsellCarousel: function () {
          if ($('#CartContainer').find('.slick-slider').length) {
            $('#CartContainer').find('.slick-slider').slick('unslick');
          }

          $('#CartContainer').find('.upsell-items').slick({
            touch: false,
            arrows: true,
            infinite: true,
            adaptiveHeight: true,
            responsive: [
              {
                breakpoint: 679,
                settings: {
                  touch: true,
                  arrows: false,
                  dots: true
                }
              }
            ]
          });

          // On init
          $('#CartContainer').find('.upsell-items').on('setPosition', function (e, slick) {
            if (slick.$slides.length > 1) {
              $(slick.$prevArrow).removeClass('hide slick-disabled');
              $(slick.$nextArrow).removeClass('hide slick-disabled');
            }
          });

          setTimeout(function () {
            $('#CartContainer').find('.upsell-items').slick('setPosition');
          }, 150);
        },

        initEvents: function () {
          // Add upsell to cart
          $('.upsell-atc').off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var slickIndex = $(e.currentTarget).closest('.slick-slide').data('slick-index');
            var variant_id = $(e.currentTarget).closest('.upsell-item').find('.variant-selector').val();
            _utils.addItemToCart({
              variant_id: variant_id,
              quantity: 1,
            })
              .then(function () {
                $('body').trigger('added.ajaxProduct');
                document.dispatchEvent(new CustomEvent('cart:build'));
                $('#CartContainer').find('.slick-slider').slick('slickRemove', slickIndex);
              });
          });
        },

        removeLoading: function () {
          var _this = this;
          $('#CartContainer .drawer__footer .cart-upsells-container').removeClass('loading');

          if (_this.productsToUpsell.length == 0) {
            $('.cart-upsells-container').hide();
          }
        },

        loadUpsells: function () {
          var _this = this;
          _this.renderUpsell();
          _this.initUpsellCarousel();
          _this.initEvents();
          setTimeout(_this.removeLoading, 0);
        },

        init: function () {

          console.log('init upsells');

          var _this = this;

          _utils.getCart().then(function (cart) {
            // remove items if already in cart
            var productIdsInCart = cart.items.map(function (item) {
              return item.product_id;
            });

            var upsell_products = productsToUpsell.filter(function (product) {
              

              return productIdsInCart.indexOf(product.id) === -1;
            });
            
            
            if (upsell_products.length == 0) {
              $('.cart-upsells-container').hide();
            } else $('.cart-upsells-container').show();
             
            

            
            _this.$set(_this, 'productsToUpsell', upsell_products);
            _this.loadUpsells()
            
          });


        }
      }
    });
  }

  $(document).ready(function () {
    initUpsellsApp();

    document.addEventListener('drawerOpen', function (evt) {
      window.upsells.init()
    }, {
      once: true,
    });

    // On drawer open, reset slick slider layout
    $('body').on('drawerOpen', function () {
      $('#CartContainer').find('.slick-slider').slick('setPosition');
    });
  });
})(jQuery);